/* KleenKick V3 — Stepper interactive (hover desktop / click mobile) */
(function () {
  'use strict';

  document.querySelectorAll('[data-kk-stepper]').forEach((stepper) => {
    const triggers = stepper.querySelectorAll('[data-kk-step-trigger]');
    const panels = stepper.querySelectorAll('[data-kk-step-panel]');
    if (!triggers.length || !panels.length) return;

    const isMobile = window.matchMedia('(max-width: 880px)');
    const isCoarse = window.matchMedia('(pointer: coarse)');

    function activate(index) {
      triggers.forEach((t, i) => {
        const active = i === index;
        t.parentElement.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((p, i) => {
        p.classList.toggle('is-active', i === index);
      });
    }

    triggers.forEach((trigger, idx) => {
      // Always handle click (works on touch + as fallback)
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        activate(idx);
      });

      // Hover only on desktop / fine pointer
      trigger.addEventListener('mouseenter', () => {
        if (isMobile.matches || isCoarse.matches) return;
        activate(idx);
      });

      // Keyboard arrows
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          const next = (idx + 1) % triggers.length;
          triggers[next].focus();
          activate(next);
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const prev = (idx - 1 + triggers.length) % triggers.length;
          triggers[prev].focus();
          activate(prev);
        }
      });
    });

    // Init first active
    activate(0);
  });
})();
